window.fisherAnalytics.quotes = {
    version: '1.0.0',
    details : 'Methods for tracking quotes - EU differs from US implementation',
    processGenerateWebQuote: function (body, response, config) {
        let cartDetails , cartDetailsJson, quoteNumber, detail = {};
        let quoteType = config.quoteType || 'Instant';
        let _transformLineItems = function (json) {
            const transformed = { products: {} };
            json.lineItems.forEach(item => {
                transformed.products[item.lineItemID] = {
                    sku: item.partNumber,
                    name: item.productTitleNoGlyphs,
                    variation: item.variation,
                    price: item.price,
                    quantity: item.quantity,
                    findingMethod:  "QuotesAddItemsToCart"
                };
            });

            return transformed;
        }

        if(localStorage.getItem('cartDetails') && localStorage.getItem('cartDetails') !== 'undefined') {
            cartDetailsJson = JSON.parse(localStorage.getItem('cartDetails'));
            if (cartDetailsJson && cartDetailsJson.lineItems && cartDetailsJson.lineItems.length > 0) {
                cartDetails = _transformLineItems(cartDetailsJson);
            }
        }

        if (response.responseText.indexOf(config.responseText) !== -1) {
            try {
                window.fisherAnalytics.utils.log('XHR request to specific create list URL with specific response detected!', config.responseText);

                if (response.status === 200) {
                    const responseJson = JSON.parse(response.responseText);
                    if (responseJson && responseJson.quoteNumber) {
                        quoteNumber = responseJson.quoteNumber;
                    }
                    detail.number = quoteNumber;
                    detail.products = cartDetails.products;
                    detail.type = quoteType;
                    document.dispatchEvent(new CustomEvent("createQuote", {"detail": detail}));

                    //Set session storage item for quote number and type to capture during downloads
                    sessionStorage.setItem('quoteNumber', quoteNumber);
                    sessionStorage.setItem('quoteType', quoteType);
                } else {
                    document.dispatchEvent(new CustomEvent("createQuoteError", {"error": response.message}));
                    sessionStorage.removeItem('quoteNumber');
                    sessionStorage.removeItem('quoteType');
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with Generate Web Quote data global ui intercept: " + e);
            }
        }
    },
    processRequestWebQuote: function (body, response, config) {
        let quoteRequestBody, detail = {}, quoteNumber, transformedProducts;
        let _convertLineItemsToProducts = function(lineItems) {
            const products = {};

            lineItems.forEach(item => {
                const key = `${item.partNumber}_${item.uom}`;
                products[key] = {
                    sku: item.partNumber,
                    name: item.productTitle.replace(/&trade;/g, '™'),
                    variation: item.uom,
                    price: parseFloat(item.unitPrice.replace('$', '')),
                    quantity: item.quantity,
                    findingMethod: "QuotesAddItemsToCart"
                };
            });

            return { products };
        }
        if (response.responseText.indexOf(config.responseText) !== -1) {

            try {
                window.fisherAnalytics.utils.log('XHR request to specific create list URL with specific response detected!', config.responseText);

                if (response.status === 200) {
                    if (body) {
                        quoteRequestBody = JSON.parse(body);
                        if (quoteRequestBody && quoteRequestBody.lineItems && quoteRequestBody.lineItems.length > 0) {
                            transformedProducts = _convertLineItemsToProducts(quoteRequestBody.lineItems);
                        }
                    }
                    const responseJson = JSON.parse(response.responseText);
                    if (responseJson && responseJson.quoteNumber) {
                        quoteNumber = responseJson.quoteNumber;
                    }
                    detail.number = quoteNumber;
                    detail.products = transformedProducts.products;
                    document.dispatchEvent(new CustomEvent("createQuote", {"detail": detail}));
                    window.fisherAnalytics.quotes.triggerDownloadEvent(null,quoteNumber);
                } else {
                    document.dispatchEvent(new CustomEvent("createQuoteError", {"error": response.message}));
                }
            } catch (e) {
                window.fisherAnalytics.utils.log("issue with Request Web Quote data global ui intercept: " + e);
            }
        }
    },
    getQuoteType: function() {
        return sessionStorage.getItem('quoteType') || null;
    },
    triggerDownloadEvent: function(event,quoteNumber) {
        //For EU, the same button is used for both Instant and Custom quotes to close the confirmation modal
        if(window.fisherAnalytics.quotes.getQuoteType() === 'Custom') {
            return;
        }
        document.dispatchEvent(new CustomEvent("fileDownload", {
            detail: {
                name: "Web Quote " + quoteNumber,
                type: "Quote",
                fileType: "pdf"
            }
        }));
    },
    triggerDownloadEventButton: function() {
        const quoteNumber = document.location.href.split('/').pop();
        if(quoteNumber) {
            window.fisherAnalytics.quotes.triggerDownloadEvent(quoteNumber);
        }
    }
}